import {siteName, siteAccessCode, siteLastContact} from '../database/apiv2SiteAccessor';
import {ContactDot} from '../Decorators/Checkmarks'

export function inRange (daysAgo, arrRange) {
  return daysAgo >= arrRange[0] && daysAgo < arrRange[1]
}

export function siteListContent (site) {
  return ([
    siteName(site), 
    siteLastContact(site) ? <ContactDot site={site} dotsize="smaller-dot" key='dot'/> : null,
    siteAccessCode(site)
  ])
}
